import { resolveStagedPreviewBackendUrl } from "@lib/util/staged-preview"

export type ContactSubmissionInput = {
  fullName: string
  email: string
  topicId: string
  message: string
  hcaptchaToken: string
}

export type ContactSubmissionResponse = {
  accepted: true
  submission_id: string
}

export type ContactSecurityResponse = {
  enabled: boolean
  site_key: string | null
}

const backendUrl = () => {
  const value = resolveStagedPreviewBackendUrl(process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL)
  if (!value) throw new Error("İletişim servisi yapılandırılmamış.")
  return value.replace(/\/+$/, "")
}

const publishableKey = () => {
  const value = process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY?.trim()
  if (!value) throw new Error("İletişim servisi yapılandırılmamış.")
  return value
}

export async function retrieveContactSecurity(): Promise<ContactSecurityResponse> {
  const response = await fetch(`${backendUrl()}/store/storefront-security?consumer=contact`, {
    method: "GET",
    headers: { "x-publishable-api-key": publishableKey() },
    cache: "no-store",
  })

  if (!response.ok) {
    throw new Error("İletişim formu koruması yüklenemedi.")
  }

  const body = await response.json() as Partial<ContactSecurityResponse>
  return {
    enabled: body.enabled === true,
    site_key: typeof body.site_key === "string" && body.site_key.trim()
      ? body.site_key.trim()
      : null,
  }
}

export async function submitContactSubmission(
  input: ContactSubmissionInput
): Promise<ContactSubmissionResponse> {
  const response = await fetch(`${backendUrl()}/store/contact-submissions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-publishable-api-key": publishableKey(),
    },
    body: JSON.stringify({
      full_name: input.fullName.trim(),
      email: input.email.trim().toLowerCase(),
      topic_id: input.topicId.trim(),
      message: input.message.trim(),
      hcaptcha_token: input.hcaptchaToken,
    }),
  })

  const body = await response.json().catch(() => null) as Partial<ContactSubmissionResponse> & { message?: unknown } | null
  if (!response.ok) {
    const message = typeof body?.message === "string" && body.message.trim()
      ? body.message.trim()
      : null
    throw new Error(message ?? "Mesajınız gönderilemedi. Lütfen tekrar deneyin.")
  }

  return {
    accepted: true,
    submission_id: typeof body?.submission_id === "string" ? body.submission_id : "",
  }
}
